import * as XLSX from 'xlsx';
import { badgeExists } from './badges';

// Column header -> datasheet mapping for the 'Fresco Netsuite Import' format.
const num = v => (v == null || v === '' ? '' : String(v));

export function sheetFromNetsuiteRow(row, base) {
  const g = (k) => { const key = Object.keys(row).find(h => h.trim().toUpperCase() === k.toUpperCase()); return key ? row[key] : ''; };
  const certs = String(g('CERTIFICATIONS') || '').split(/[,/]/).map(x => x.trim()).filter(Boolean);
  const badges = { ...(base.badges || {}) };
  certs.forEach(c => { if (badgeExists(c)) badges[c] = true; });

  const model = g('DISPLAY NAME/CODE-SALES') || g('ITEM NAME/NUMBER INTERNAL');
  return {
    ...base,
    name: g('FAMILY') || g('SERIES') || base.name,
    variant: g('SUB CATEGORY') || base.variant,
    code: model || base.code,
    salesDescription: g('SALES DESCRIPTION') || base.salesDescription,
    purchaseDescription: g('PURCHASE DESCRIPTION') || base.purchaseDescription,
    datasheetLink: g('DATASHEET LINK') || base.datasheetLink,
    netsuiteInternal: g('ITEM NAME/NUMBER INTERNAL') || base.netsuiteInternal,
    productDetails: {
      ...(base.productDetails || {}),
      lightOutput: num(g('SYSTEM LUMENS (LM)')) ? num(g('SYSTEM LUMENS (LM)')) + 'lm' : (base.productDetails || {}).lightOutput,
      optic: g('OPTICAL SYSTEM') || (base.productDetails || {}).optic,
      weight: num(g('PRODUCT NET WEIGHT')) ? num(g('PRODUCT NET WEIGHT')) + (g('Weight Unit') || 'kg') : (base.productDetails || {}).weight,
      powerFactor: num(g('POWER FACTOR (V)')) || (base.productDetails || {}).powerFactor,
      efficacy: num(g('EFFICACY (LM/W)')) || (base.productDetails || {}).efficacy,
      ugr: num(g('UGR')) || (base.productDetails || {}).ugr,
      macadam: num(g('MACADAM')) || (base.productDetails || {}).macadam,
      class: g('CLASS OF PROTECTION') || (base.productDetails || {}).class,
    },
    commonSpecs: {
      ...(base.commonSpecs || {}),
      cri: num(g('CRI')) || (base.commonSpecs || {}).cri,
      cct: g('COLOUR TEMP') || (base.commonSpecs || {}).cct,
      material: g('MAIN MATERIAL') || (base.commonSpecs || {}).material,
      ledLifetime: num(g('LED LIFETIME (HRS)')) ? num(g('LED LIFETIME (HRS)')) + 'hrs' : (base.commonSpecs || {}).ledLifetime,
      colour: g('FITTING COLOUR') || (base.commonSpecs || {}).colour,
      voltage: g('SUPPLY VOLTAGE (V)') || (base.commonSpecs || {}).voltage,
      dimming: g('DIMMING OPTIONS') || (base.commonSpecs || {}).dimming,
    },
    badges,
    variants: [{
      model,
      sourcePower: num(g('SOURCE WATTAGE (W)')),
      systemPower: num(g('SYSTEM WATTAGE (W)')),
      sourceLumens: num(g('SOURCE LUMENS (LM)')),
    }],
  };
}

export function netsuiteRowFromSheet(s) {
  const pd = s.productDetails || {}, cs = s.commonSpecs || {};
  const v0 = (s.variants || [])[0] || {};
  const certs = Object.keys(s.badges || {}).filter(k => (s.badges || {})[k]);
  return {
    'ITEM NAME/NUMBER INTERNAL ': s.netsuiteInternal || s.code || '',
    'SALES DESCRIPTION': s.salesDescription || '',
    'DISPLAY NAME/CODE-SALES': s.code || '',
    'PURCHASE DESCRIPTION': s.purchaseDescription || '',
    'DATASHEET LINK': s.datasheetLink || '',
    'FAMILY': s.name || '',
    'SUB CATEGORY': s.variant || '',
    'FITTING COLOUR': cs.colour || '',
    'MAIN MATERIAL': cs.material || '',
    'CERTIFICATIONS': certs.join(', '),
    'SYSTEM WATTAGE (W)': v0.systemPower || '',
    'SOURCE WATTAGE (W)': v0.sourcePower || '',
    'SUPPLY VOLTAGE (V)': cs.voltage || '',
    'POWER FACTOR (V)': pd.powerFactor || '',
    'CLASS OF PROTECTION': pd.class || '',
    'DIMMING OPTIONS': cs.dimming || '',
    'SYSTEM LUMENS (LM)': (pd.lightOutput || '').replace(/[^0-9.]/g, ''),
    'SOURCE LUMENS (LM)': v0.sourceLumens || '',
    'EFFICACY (LM/W)': pd.efficacy || '',
    'CRI': cs.cri || '',
    'COLOUR TEMP': cs.cct || '',
    'MACADAM': pd.macadam || '',
    'LED LIFETIME (HRS)': (cs.ledLifetime || '').replace(/[^0-9.]/g, ''),
    'UGR': pd.ugr || '',
    'OPTICAL SYSTEM': pd.optic || '',
    'PRODUCT NET WEIGHT': (pd.weight || '').replace(/[^0-9.]/g, ''),
  };
}

export function parseNetsuiteFile(file) {
  return new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = (e) => {
      try {
        const wb = XLSX.read(e.target.result, { type: 'array' });
        const ws = wb.Sheets[wb.SheetNames[0]];
        const rows = XLSX.utils.sheet_to_json(ws, { defval: '' });
        const first = rows.find(rw => Object.values(rw).some(v => v !== '' && v != null));
        if (!first) return reject(new Error('No data rows found'));
        resolve(first);
      } catch (err) { reject(err); }
    };
    r.onerror = () => reject(new Error('Could not read file'));
    r.readAsArrayBuffer(file);
  });
}

export function exportNetsuiteFile(sheet) {
  const row = netsuiteRowFromSheet(sheet);
  const ws = XLSX.utils.json_to_sheet([row]);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Netsuite');
  const fname = (sheet.code || sheet.name || 'netsuite_export').replace(/[^a-zA-Z0-9_-]+/g, '_') + '_netsuite.xlsx';
  XLSX.writeFile(wb, fname);
}
